import React from "react";
import { Flex } from "@chakra-ui/react";

export default function FormFieldCharactersRemaining({currentValue, characterLimit}) {

  if (Number.isInteger(characterLimit)) {
    const remainingChar = currentValue ? characterLimit - currentValue?.trim().length : characterLimit;

    return (
      <Flex justify='flex-end' w='100%' color='gray.500' fontSize='0.65em' pt='0.2em'>
      {remainingChar} characters remaining
    </Flex>
    );
  }
 
  
}


